module.exports = __webpack_public_path__ + "img/camera_on.85bc173b.png";